import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon
} from "@heroicons/react/20/solid";
import type React from "react";
import { twMerge } from "tailwind-merge";
import TextWithIcon from "../text-with-icon-row/TextWithIconRow.react";

export enum AlertType {
  Info,
  Danger,
  Warning,
  Success
}

export type AlertProps = {
  type?: AlertType;
  title?: string;
  description?: string;
} & React.ComponentPropsWithoutRef<"div">;

export const Alert = ({
  className,
  children,
  title,
  type = AlertType.Info,
  ...props
}: AlertProps) => {
  let icon = <InformationCircleIcon />;
  let divClasses =
    "bg-alert_info-bg border-blue-500  dark:text-white dark:bg-slate-900 dark:text-white border-slate-50 dark:border-slate-700";
  let iconColor = "text-alert_info-icon dark:text-white ";
  let textColor = "text-alert_info-text";
  let titleColor = "text-alert_info-title text-black";
  if (type === AlertType.Danger) {
    icon = <ExclamationCircleIcon />;
    divClasses = "bg-red-100 border-red-500 dark:bg-slate-900";
    iconColor = "text-red-500";
    textColor = "text-red-500";
    titleColor = "text-red-500";
  } else if (type === AlertType.Warning) {
    icon = <ExclamationCircleIcon />;
    divClasses =
      "bg-orange-100 border-orange-500 text-black dark:bg-orange-800 dark:border-orange-700 dark:text-white";
    iconColor = "text-orange-500";
    textColor = "text-orange-500";
    titleColor = "text-orange-900";
  } else if (type === AlertType.Success) {
    icon = <CheckCircleIcon />;
    divClasses =
      "bg-green-100 border-green-500 text-black  dark:bg-green-800 dark:border-green-700 dark:text-white";
    iconColor = "text-green-500";
    textColor = "text-green-500";
    titleColor = "text-green-900";
  }

  return (
    <div
      className={twMerge(
        "rounded-sm border-2 px-1 py-4 md:px-4",
        divClasses,
        className,
        !title && "flex gap-2"
      )}
      {...props}
    >
      <TextWithIcon iconColor={iconColor} suffixIcon={icon}>
        <span className={`font-semibold text-sm dark:text-white ${titleColor}`}>{title}</span>
      </TextWithIcon>
      <div className={twMerge("flex-1", textColor && "sm:ml-8")}>{children}</div>
    </div>
  );
};
